import { useTimelineContext } from 'dnd-timeline';
import { type ScheduleView, dayBands } from './dropLogic.js';

/**
 * #631 — a faint tint behind the rows for weekend days and today (Week and Month). Behind the bars,
 * never a hit target, and not a drop hint: it says what day it is, nothing about availability.
 */
export function DayShading({ view, now }: { view: ScheduleView; now: number }) {
  const { range, valueToPixels, sidebarWidth } = useTimelineContext();
  return (
    <>
      {dayBands(range, view, now).map((band) => (
        <div
          key={band.start}
          data-testid={`schedule-day-${band.kind}`}
          data-start={band.start}
          aria-hidden="true"
          className={[
            'pointer-events-none absolute top-0 bottom-0',
            band.kind === 'today' ? 'bg-surface-feature/60' : 'bg-surface-soft',
          ].join(' ')}
          style={{
            left: sidebarWidth + valueToPixels(band.start - range.start),
            width: valueToPixels(band.end - band.start),
          }}
        />
      ))}
    </>
  );
}
